import { render, staticRenderFns } from "./ProjectGroupDetailsArchive.vue?vue&type=template&id=765dda9c&"
import script from "./ProjectGroupDetailsArchive.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroupDetailsArchive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports